import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider';

const containerWidth = {
  width: `500px`
}

class Index extends React.Component {
  timeout = null
  state = {
    dots: 20
  }

  handle = (props) => {
    const { value, dragging, index, ...restProps } = props;

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      if (this.state.dots !== value) {
        this.setState({
          dots: value
        })
      }
    }, 100)

    return (
      <Tooltip
        prefixCls="rc-slider-tooltip"
        overlay={`${value} dots per color`}
        visible={dragging}
        placement="top"
        key={index}
      >
        <Slider.Handle value={value} {...restProps} />
      </Tooltip>
    );
  }

  render () {
    const props = {
      mode: 'capture', // select('Mode', ['capture', 'kill'], 'capture'),
      movement: 'directional', // select('Movement', ['directional', 'random'], 'directional'),
      squares: 18, // number('Size', 18),
      startingHealth: 50, // number('Health', 50),
      starvation: false, // boolean('Starvation', false),
      enemies: {
        red: this.state.dots,
        green: this.state.dots,
        blue: this.state.dots
      }
    }

    return (
      <React.Fragment>
        <div className='controls' style={containerWidth}>
          <Slider min={20} max={100} defaultValue={20} handle={this.handle} />
        </div>
        <App {...props} />
      </React.Fragment>
    )
  }
}

ReactDOM.render(<Index />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js